module.exports = __webpack_public_path__ + "static/media/coding.3c561624.svg";